/* SUDADEROTAS · «Tipo de puntada»: el cliente elige cómo se teje su prenda (diseños tejidos de Navidad, Tu equipo, Familia y Profesión).
   Se carga después del núcleo y antes de los estilos: envuelve cada estilo para agregar el selector, el resumen y el dato del pedido. */
(function (root) {
"use strict";
var SDRP = root.SDRP;
if (!SDRP || SDRP._puntadas) return;
SDRP._puntadas = true;
var USAN = { navidad: 1, equipo: 1, familia: 1, profesion: 1 };
var css = document.createElement("style");
css.textContent = ".sdr-puntos{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin:4px 0 6px}@media (min-width:600px){.sdr-puntos{grid-template-columns:repeat(4,minmax(0,1fr))}}" +
".sdr-punto{display:grid;gap:4px;justify-items:center;padding:6px;border:2px solid var(--sdr-linea);border-radius:14px;background:#fff;cursor:pointer;font-size:13px;font-weight:800;text-align:center;line-height:1.15}" +
".sdr-punto canvas{width:100%;max-width:96px;aspect-ratio:3/2;border-radius:8px}.sdr-punto[aria-checked=true]{border-color:var(--sdr-rojo);box-shadow:0 0 0 2px var(--sdr-rojo)}";
document.head.appendChild(css);
function T() { return root.SDRKit && root.SDRKit.tej; }
function nombreDe(id) { var L = (T() && T().PUNTADAS) || []; for (var i = 0; i < L.length; i++) if (L[i][0] === id) return L[i][1]; return ""; }
function muestra(cv, id) {
var t = T(); if (!t) return; var x = cv.getContext("2d"), W = cv.width, H = cv.height, cw = W / 6, ch = cw * t.CH / t.CW;
var dib = id === "v" || !t.PUNTOS[id] ? function (c, X, Y, w, h, col) { t.puntada(c, X, Y, w, h, col); } : t.PUNTOS[id].lienzo;
x.fillStyle = "#7a1626"; x.fillRect(0, 0, W, H);
for (var j = 0; j * ch < H; j++) for (var i = 0; i < 6; i++) {
var col = (j === 1 || j === 2) && (i + j) % 3 === 0 ? "#fff6ec" : "#d42f47";
x.fillStyle = "#7a1626"; x.fillRect(i * cw, j * ch, cw, ch); dib(x, i * cw, j * ch, cw, ch, col);
}
}
function decorar(E) {
var api = null, caja = null, M = null;
/* en Navidad solo aplica a los diseños tejidos; en los de equipo siempre */
function aplica() {
if (!api) return false;
if (E.id !== "navidad") return true;
var d = M.DISENOS[M.disenoDe(api.estado)];
return !!(d && d.puntada);
}
function porDefecto() { if (T() && T().PUNTOS && T().PUNTOS.k3d) return "k3d"; if (E.id !== "navidad") return "v"; var d = M.DISENOS[M.disenoDe(api.estado)]; return (d && d.puntada) || "v"; }
function elegida() { var p = api.estado.puntada; return p && (p === "v" || (T() && T().PUNTOS[p])) ? p : porDefecto(); }
function marcar() {
if (!caja) return;
caja.hidden = !aplica();
var p = elegida();
caja.querySelectorAll(".sdr-punto").forEach(function (b) { b.setAttribute("aria-checked", b.dataset.id === p); });
}
function montarSelector(cj) {
var t = T(); if (!t || !t.PUNTADAS) return;
caja = document.createElement("div"); caja.className = "sdr-puntadas";
caja.innerHTML = '<h3 class="sdr-sub">Tipo de puntada</h3><p class="sdr-ayuda">Elige cómo se ve el tejido de tu prenda. Cambia el fondo, las letras y tu foto.</p><div class="sdr-puntos" role="radiogroup" aria-label="Tipo de puntada"></div>';
var g = caja.querySelector(".sdr-puntos");
t.PUNTADAS.forEach(function (o) {
var b = document.createElement("button"), c = document.createElement("canvas");
b.type = "button"; b.className = "sdr-punto"; b.dataset.id = o[0]; b.setAttribute("role", "radio"); c.width = 192; c.height = 128;
b.appendChild(c); b.appendChild(document.createTextNode(o[1])); muestra(c, o[0]);
b.addEventListener("click", function () { api.estado.puntada = o[0]; marcar(); api.cambio(); });
g.appendChild(b);
});
var ancla = cj.querySelector(".sdr-disenos") || cj.querySelector(".sdr-equipos");
if (ancla && E.id === "navidad") ancla.insertAdjacentElement("afterend", caja); else cj.appendChild(caja);
marcar();
}
var montar = E.montar;
E.montar = function (cj, a) { api = a; M = a.M; try { if (!a.estado.puntada && T() && T().PUNTOS && T().PUNTOS.k3d) a.estado.puntada = "k3d"; } catch (e) {} var r = montar.apply(this, arguments); try { montarSelector(cj); } catch (e) {} return r; };
["entrar", "dibujar"].forEach(function (k) {
var f = E[k];
E[k] = function () { var r = f ? f.apply(this, arguments) : undefined; try { marcar(); } catch (e) {} return r; };
});
var config = E.config;
E.config = function () { var c = config ? config.apply(this, arguments) : {}; if (aplica()) c.puntada = elegida(); return c; };
var props = E.propiedades;
E.propiedades = function (fd) { var r = props ? props.apply(this, arguments) : undefined; if (aplica()) fd.append("properties[Puntada]", nombreDe(elegida())); return r; };
var resumen = E.resumen;
E.resumen = function () { var f = resumen ? resumen.apply(this, arguments) : []; if (aplica()) f = f.concat([["Puntada", nombreDe(elegida())]]); return f; };
}
var orig = SDRP.estilo;
SDRP.estilo = function (E) { if (E && USAN[E.id]) try { decorar(E); } catch (e) {} return orig.apply(this, arguments); };
})(this);
